import { render, staticRenderFns } from "./ChefForward.vue?vue&type=template&id=4b32090f&"
import script from "./ChefForward.vue?vue&type=script&lang=js&"
export * from "./ChefForward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports